import { useState, useEffect } from 'react';
import { func, object, shape } from 'prop-types';
import { useConfig } from '@ynap/immutables-provider';
import { formatScreens } from './helper';

const configSelector = (config) => ({
    brandId: config.head.theme,
});

const MediaQuery = ({ screens }) => {
    const [currentMediaQuery, setCurrentMediaQuery] = useState();
    const { brandId } = useConfig(configSelector);
    const mediaQueriesList = formatScreens(screens, brandId) || [];
    const component = mediaQueriesList?.find(({ mediaQuery }) => mediaQuery === currentMediaQuery)?.child?.();

    const handleMediaQuery = () => {
        mediaQueriesList.forEach((item) => {
            item.match = window.matchMedia(item.mediaQuery);
            item.match.addListener(handleMediaQuery);
            item.match.matches && setCurrentMediaQuery(item.mediaQuery);
        });
    };

    useEffect(() => {
        if (typeof window === 'object' && window.matchMedia) {
            handleMediaQuery();
        }

        return () => {
            mediaQueriesList.map((item) => {
                item.match.removeListener(handleMediaQuery);
                delete item.match;
            });
        };
    }, []);

    return component || null;
};

MediaQuery.propTypes = {
    screens: shape({
        phone: func,
        tablet: func,
        desktop: func,
        smallerDesktop: func,
        largeDesktop: func,
    }),
};

export default MediaQuery;
